import { IgetSearchConditionListFilters } from '@/store/specialist/index.d';

export enum FILTER_TYPE_ENUM {
  CITY,
  DEPARTMENT,
  CONDITION,
  HOSPITALS_TYPE
}

export enum FILTER_TELESCOPE_ENUM {
  CITY,
  DEPARTMENT,
  CONDITION,
  HOSPITALS_TYPE,
  SELECT_CITY,
  SELECT_DEPARTMENT,
  SELECT_CONDITION,
  CONDITION_RESET,
  CONDITION_CONFIRM
}

export interface IfilterVaule {
  [k: number]: ItreeSelectItemChild | IdropdownValues;
}

export interface ItreeSelectItemChild {
  // 名称
  text: string;
  // id，作为匹配选中状态的标识符
  id: number | string;
  isLocation?: boolean;
  // 禁用选项
  disabled?: boolean;
  level?: number;
  parentIndex: number;
  parentId?: number | string;
  parentText?: string;
}

export interface ItreeSelectItem {
  // 导航名称
  text: string;
  id: string | number;
  level?: number;
  // 导航名称右上角徽标，2.5.6 版本开始支持
  badge?: string;
  // 是否在导航名称右上角显示小红点
  dot?: boolean;
  // 导航节点额外类名
  className?: string;
  // 该导航下所有的可选项
  children: ItreeSelectItemChild[];
}

export interface ItreeSelect {
  activeIndex: number | string;
  activeId: number | string;
  items: ItreeSelectItem[];
}

export interface Idropdown {
  options: IgetSearchConditionListFilters[];
  values?: IdropdownValues;
  isMuitl?: boolean;
  isConfirm?: boolean;
}

export interface IdropdownValues {
  [k: number]: number | number[];
}

export interface IfilterRender {
  init: () => Promise<void>;
  dropdown?: Idropdown;
  tree?: Partial<ItreeSelect>;
  title: string;
  tempTitle?: string;
  defaultTitle: string;
}
